/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_No_Issues_ExportInputs */

const en_manual_qc_no_issues_export = /** @type {(inputs: Manual_Qc_No_Issues_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No issues to export`)
};

const fr_manual_qc_no_issues_export = /** @type {(inputs: Manual_Qc_No_Issues_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun incident a exporter`)
};

const de_manual_qc_no_issues_export = /** @type {(inputs: Manual_Qc_No_Issues_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Probleme beim Export`)
};

const it_manual_qc_no_issues_export = /** @type {(inputs: Manual_Qc_No_Issues_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun problema da esportare`)
};

const ru_manual_qc_no_issues_export = /** @type {(inputs: Manual_Qc_No_Issues_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проблем с экспортом нет.`)
};

const es_manual_qc_no_issues_export = /** @type {(inputs: Manual_Qc_No_Issues_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay problemas para exportar`)
};

const zh_cn2_manual_qc_no_issues_export = /** @type {(inputs: Manual_Qc_No_Issues_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出无问题`)
};

const ja_manual_qc_no_issues_export = /** @type {(inputs: Manual_Qc_No_Issues_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートする問題はありません`)
};

const hi_manual_qc_no_issues_export = /** @type {(inputs: Manual_Qc_No_Issues_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात में कोई समस्या नहीं है`)
};

const pt_pt2_manual_qc_no_issues_export = /** @type {(inputs: Manual_Qc_No_Issues_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar sem problemas.`)
};

/**
* | output |
* | --- |
* | "No issues to export" |
*
* @param {Manual_Qc_No_Issues_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_no_issues_export = /** @type {((inputs?: Manual_Qc_No_Issues_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_No_Issues_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_no_issues_export(inputs)
	if (locale === "de") return de_manual_qc_no_issues_export(inputs)
	if (locale === "it") return it_manual_qc_no_issues_export(inputs)
	if (locale === "ru") return ru_manual_qc_no_issues_export(inputs)
	if (locale === "es") return es_manual_qc_no_issues_export(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_no_issues_export(inputs)
	if (locale === "ja") return ja_manual_qc_no_issues_export(inputs)
	if (locale === "hi") return hi_manual_qc_no_issues_export(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_no_issues_export(inputs)
	return en_manual_qc_no_issues_export(inputs)
});